/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * RefundRechargeModal
 *
 */

import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Modal, ModalContent, ModalHeader } from '@cashfree-intl/coherent';

import { DATE_AND_TIME_FORMAT } from 'utils/constants';
import { getCurrencySymbol, roundOffNumber } from 'utils/common';
import useClickOutside from 'utils/hooks';

import CustomIcon from 'components/CustomIcons';
import InlineLoader from 'components/InlineLoader';
import TableDataNotFound from 'components/TableDataNotFound';

function RefundRechargeModal({
  open,
  closeModal,
  data,
  getUpdatedData,
  loader,
}) {
  const modalRef = useRef(null);

  useClickOutside(modalRef, closeModal);

  const handleListScroll = e => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 5) getUpdatedData();
  };

  return (
    <Modal
      open={open}
      className="common-modal-wrapper refund-recharge-modal"
      ref={modalRef}
    >
      <ModalHeader>
        <div>
          <div className="heading">Recharge Account Ledger</div>
        </div>
        <div
          className="close-modal"
          onClick={closeModal}
          data-event-name="Form_RefundRechargeModal_Icon_Close"
          data-ignore-inner-text="true"
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="modal-content">
          <div className="refund-recharge-description">
            <div className="column-left content-header">Date &amp; Time</div>
            <div className="content-header">Amount</div>
          </div>
          <div className="divider title-divider" />
          <div
            className={`scrollable-list ${!data.length ? 'no-data' : ''}`}
            onScroll={handleListScroll}
          >
            <div className="refund-recharge-body">
              {data.map(obj => (
                <div key={obj.addedOn}>
                  <div className="refund-recharge-description">
                    <div className="column-left">
                      {moment(obj.addedOn).format(DATE_AND_TIME_FORMAT)}
                    </div>
                    <div>
                      {getCurrencySymbol()} {roundOffNumber(obj.amount)}
                    </div>
                  </div>
                  <div className="divider" />
                </div>
              ))}
              {!data.length && <TableDataNotFound />}
            </div>
          </div>
          <div className="loader">
            <InlineLoader loading={loader} content={null} />
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}

RefundRechargeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  getUpdatedData: PropTypes.func.isRequired,
  loader: PropTypes.bool.isRequired,
};

export default memo(RefundRechargeModal);
